import * as tslib_1 from "tslib";
import { Vue, Prop, Component } from "vue-property-decorator";
let HImage = class HImage extends Vue {
};
tslib_1.__decorate([
    Prop({
        default: ''
    })
], HImage.prototype, "text", void 0);
HImage = tslib_1.__decorate([
    Component({
        name: 'h-image'
    })
], HImage);
export default HImage;
